import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ReactTooltip from 'react-tooltip';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
// import './Skills.scss';

const Skills = () => {
  const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    const query = '*[_type == "experiences"]';
    const skillsQuery = '*[_type == "skills"]';

    client.fetch(query).then((data) => {
      setExperiences(data);
    });

    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
    });
  }, []);

  return (
    <>
  

   
      <h2 className="text-blue-600 font-extrabold text-5xl text-center capitalize sm:text-4xl xl:text-4xl  " data-aos='flip-up' >Skills & Experiences</h2>

      <div className="xl:grid  xl:grid-cols-2 xl:gap-2 lg:grid lg:grid-cols-2 lg:gap-2 md:grid md:grid-cols-2 md:gap-4   sm:grid-cols-2 sm:gap-2 ">
        <motion.div className=" grid grid-cols-3 gap-6 md:items-center  items-start justify-start flex-grow mr-20  w-1/2  ">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="flex-col m-4 text-center  flex items-center justify-center"
              key={skill.name}
            >
              <div
                className="flex  items-center justify-center w-26 h-20 hover:shadow-lg bg-gray-300 rounded-full md:w-14 md:h-14 md:rounded-full sm:w-16 sm:h-16  "
                style={{ backgroundColor: skill.bgColor }}
              >
                <img className=' bg-white rounded-full  w-1/2 h-1/2 ' src={urlFor(skill.icon)} alt={skill.name}   />
              </div>
              <p className="font-medium text-blue-600 mt-2 xl:mt-4 text-xs leading-normal text-left">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="flex  flex-col items-start justify-start flex-grow mt-8   lg:mt-8">
          {experiences.map((experience) => (
            <motion.div
              className="flex  flex-row items-start justify-start mx-0 my-4 w-full"
              key={experience.year}
            >
              <div className="mr-12" data-aos='flip-right'>
                <p className="font-extrabold text-blue-600 sm:mr-0.5">{experience.year}</p>
              </div>
              <motion.div className="cursor-pointer flex flex-col items-start justify-start mb-4">
                {experience.works.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="cursor-pointer flex flex-col  items-start justify-start mb-4"
                      data-aos='flip-left'
                      data-tip
                      data-for={work.name}
                      key={work.name}
                    >
                      <h4 className="font-extrabold text-base text-left text-gray-600">{work.name}</h4>
                      <p className="text-xs leading-normal text-left text-gray-600 ">{work.company}</p>
                    </motion.div>
                    <ReactTooltip
                      id={work.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="max-w-xs inline-block absolute invisible z-20 py-2 px-3 text-sm font-medium text-gray-600 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-blue-700"
                    >
                      {work.desc}
                    </ReactTooltip>
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
      
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'flex-1 w-full flex-col'),
  'skills',
  'bg-white',
);